import { Component, Input, OnInit } from '@angular/core';
import { BaseProfileComponent } from '../base-profile.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ProfileMapper } from '../profile-mapper';
import { equalValidator } from 'src/app/shared/input-components/validators/equal.validator';

@Component({
  selector: 'app-profile-account-info',
  templateUrl: './profile-account-info.component.html',
})
export class ProfileAccountInfoComponent
  extends BaseProfileComponent
  implements OnInit
{
  @Input() form: FormGroup;

  constructor(
    translateService: TranslateService,
    protected _mapper: ProfileMapper
  ) {
    super(translateService, _mapper);
  }

  ngOnInit(): void {
    this.form.addControl(
      'ParticipantNumber',
      new FormControl(null, Validators.required)
    );
    this.form.addControl(
      'Username',
      new FormControl(null, Validators.required)
    );
    this.form.addControl(
      'Email',
      new FormControl(null, [Validators.required, Validators.email])
    );
    this.form.addControl(
      'ConfirmEmail',
      new FormControl(null, [Validators.required, equalValidator('Email')])
    );
  }
}
